import { ctor } from 'from2';
import { async } from 'regenerator-runtime';
import {
  req,
  breq,
  imgServer,
  getWebsiteData,
  getCarFaxReport,
  googlePlaceDataAPI,
} from '../js/config';

import { currencyFormatter } from '../js/base';
//import { ToHTML, ToHTMLWithFormatting } from "../js/base";
//import { async } from "regenerator-runtime";

let PageData = {};
let CarData = {};

const Initialize = async () => {
  try {
    const queryData = await readQueryString(window.location.href);
    await getPageData(queryData.id);
    await generatePageHTML();
    await loadJavascriptNow();
    await sidebarRecentListings();
    const loader = document.querySelector('.loader');
    loader.className += ' hidden'; // class "loader
  } catch (err) {
    console.log('🚀 ~ file: main.js:22 ~ Initialize ~ err', err);
    // window.location = "index.html"
  }
};

const readQueryString = async (url) => {
  const paramArr = url.slice(url.indexOf('?') + 1).split('&');
  const params = {};
  paramArr.map((param) => {
    const [key, val] = param.split('=');
    params[key] = decodeURIComponent(val);
  });
  return params;
};

const getPageData = async (carId) => {
  PageData = await getWebsiteData();
  CarData = PageData.filter((s) => s.id == carId);
  console.log(CarData);
};

// Function to display loading message
const displayLoadingMessage = () => {
  document.querySelector('#carFaxData').innerHTML = 'CarFax loading...';
};

const generatePageHTML = async () => {
  await generateSlider();
  await generateBreadcrumbData();
  await generateTitleAndPrice();
  await generateOtherDetailData();
  console.log('get car fax');
  displayLoadingMessage(); // Display a loading message for CarFax data
  generateSideBarData();
  console.log('car fax retrieved');

  document.querySelector('#copyrightYearsFooter').innerHTML =
    '&copy;' +
    new Date().getFullYear() +
    ' <span> Hansen Truck & Car Sales</span';
  document.querySelector('#copyrightYearsMobileMenu').innerHTML =
    '&copy;' +
    new Date().getFullYear() +
    ' <span> Hansen Truck & Car Sales</span';
  // Enhanced SEO title with more keywords
  const carYear = CarData[0].attributes.Year;
  const carMake = CarData[0].attributes.Make;
  const carModel = CarData[0].attributes.Model;
  const carPrice = CarData[0].attributes.Price;
  const carMileage = CarData[0].attributes.Odometer;

  const seoTitle = `${carYear} ${carMake} ${carModel} For Sale Brampton | ${currencyFormatter.format(
    carPrice
  )} | Hansen Cars`;
  document.querySelector('#pageTitle').innerHTML = seoTitle;

  // Generate all SEO metadata
  await generateSEOMetadata();

  let testimonials = await googlePlaceData();
  if (testimonials != null) {
    await generateSideBarDealerInfoData(testimonials);
    await updateCurrentDayHours(testimonials.opening_hours);

    await phoneNumber(testimonials.formatted_phone_number);

    await address(testimonials.formatted_address);

    // await buildTestimonials(testimonials);
  }
};

const buildTestimonialStarRating = (r) => {
  let tmp = '';

  for (let index = 0; index < r.rating; index++) {
    tmp += '<li class="rating-on"> <i class="ion-ios-star"></i></li>';
  }

  return tmp;
};

const buildTestimonials = async () => {
  let t = await googlePlaceData();
  console.log(t);
  let tmp = '';

  t.reviews.forEach((r) => {
    tmp += `     <li>
    <div class="single-reviews-comment">
        <div class="comment-author">
            <img src="${r.profile_photo_url}" alt="">
        </div>
        <div class="comment-content">
            <div class="rating-name">
                <ul class="author-rating">
                ${buildTestimonialStarRating(r)}
                </ul>
               
            </div>
            <ul class="meta">
                <li>by ${r.author_name} <a href="${
      r.author_url
    }">Google Reviews</a></li>
                <li>${r.relative_time_description}</li>
            </ul>
            <p>${r.text}</p>
            
        </div>
    </div>
</li>`;
  });

  return tmp;
};

const updateCurrentDayHours = async (h) => {
  try {
    if (
      !h ||
      !h.weekday_text ||
      !Array.isArray(h.weekday_text) ||
      h.weekday_text.length === 0
    ) {
      console.warn('Invalid opening hours data, using default hours');
      showDefaultBusinessHours();
      return;
    }

    let currentDay = new Date().getDay();
    currentDay == 0 ? (currentDay = 7) : currentDay;

    if (currentDay > 0 && currentDay <= h.weekday_text.length) {
      const currentDayElement = document.querySelector('#currentDayHours');
      if (currentDayElement) {
        currentDayElement.innerHTML = h.weekday_text[currentDay - 1];
      }
    }

    let tpa = '';
    for (let i = 0; i < h.weekday_text.length; i++) {
      if (h.weekday_text[i]) {
        tpa += `<li>${h.weekday_text[i]}</li>`;
      }
    }

    const workingHoursElement = document.querySelector('#workingHours');
    if (workingHoursElement) {
      workingHoursElement.innerHTML = tpa;
    }
  } catch (error) {
    console.error('Error updating business hours:', error);
    showDefaultBusinessHours();
  }
};

const showDefaultBusinessHours = () => {
  const defaultHours = [
    'Monday: 9:00 AM - 7:00 PM',
    'Tuesday: 9:00 AM - 7:00 PM',
    'Wednesday: 9:00 AM - 7:00 PM',
    'Thursday: 9:00 AM - 7:00 PM',
    'Friday: 9:00 AM - 7:00 PM',
    'Saturday: 9:00 AM - 5:00 PM',
    'Sunday: 11:00 AM - 4:00 PM',
  ];

  const currentDayElement = document.querySelector('#currentDayHours');
  const workingHoursElement = document.querySelector('#workingHours');

  if (currentDayElement) {
    const currentDay = new Date().getDay();
    const adjustedDay = currentDay === 0 ? 6 : currentDay - 1;
    currentDayElement.innerHTML = defaultHours[adjustedDay] || 'Call for hours';
  }

  if (workingHoursElement) {
    const hoursHtml = defaultHours.map((hour) => `<li>${hour}</li>`).join('');
    workingHoursElement.innerHTML = hoursHtml;
  }
};

const phoneNumber = async (p) => {
  try {
    const defaultPhone = '(905) 463-0928';
    const phone = p && typeof p === 'string' ? p : defaultPhone;
    const phoneHTML = `<a href="tel:${phone.replace(
      /[\s\-\(\)]+/g,
      ''
    )}">${phone}</a>`;

    const phoneElement = document.querySelector('#phoneNumber');
    const footerPhoneElement = document.querySelector('#footerPhoneNumber');

    if (phoneElement) phoneElement.innerHTML = phoneHTML;
    if (footerPhoneElement) footerPhoneElement.innerHTML = phoneHTML;
  } catch (error) {
    console.error('Error setting phone number:', error);
    const fallback = '<a href="tel:9054630928">(905) 463-0928</a>';
    const phoneElement = document.querySelector('#phoneNumber');
    const footerPhoneElement = document.querySelector('#footerPhoneNumber');

    if (phoneElement) phoneElement.innerHTML = fallback;
    if (footerPhoneElement) footerPhoneElement.innerHTML = fallback;
  }
};

const address = async (a) => {
  try {
    const defaultAddress = '5 Hansen Rd S, Brampton, ON L6W 3H6, Canada';
    const address = a && typeof a === 'string' ? a : defaultAddress;
    const addressHTML = `<a href="https://www.google.com/maps?q=${encodeURIComponent(
      address
    )}" target="_blank">${address}</a>`;

    const addressElement = document.querySelector('#address');
    const footerAddressElement = document.querySelector('#footerAddress');

    if (addressElement) addressElement.innerHTML = addressHTML;
    if (footerAddressElement) footerAddressElement.innerHTML = addressHTML;
  } catch (error) {
    console.error('Error setting address:', error);
    const fallbackAddress = '5 Hansen Rd S, Brampton, ON L6W 3H6, Canada';
    const fallbackHTML = `<a href="https://www.google.com/maps?q=${encodeURIComponent(
      fallbackAddress
    )}" target="_blank">${fallbackAddress}</a>`;

    const addressElement = document.querySelector('#address');
    const footerAddressElement = document.querySelector('#footerAddress');

    if (addressElement) addressElement.innerHTML = fallbackHTML;
    if (footerAddressElement) footerAddressElement.innerHTML = fallbackHTML;
  }
};

const generateSideBarData = async () => {
  //carfax data with comprehensive error handling
  let cftmp = '';

  try {
    // Check if VIN is available
    const vin = CarData[0]?.attributes?.VIN;
    if (!vin || vin.length < 17) {
      console.warn('VIN not available or invalid for CarFax lookup');
      cftmp = `<div class="carfax-professional">
                 <div class="carfax-card">
                   <div class="carfax-content">
                     <h4>Vehicle History Report</h4>
                     <p><i class="ion-information-circled"></i> Report not available for this vehicle</p>
                   </div>
                 </div>
               </div>`;
    } else {
      console.log('Fetching CarFax report for VIN:', vin);
      const cfData = await getCarFaxReport(vin);

      // Check if CarFax data is valid and has the expected structure
      if (cfData?.data?.ResponseData?.Badges?.[0]?.VhrReportUrl) {
        const badge = cfData.data.ResponseData.Badges[0];
        cftmp = `<div class="carfax-professional">
                   <div class="carfax-card">
                     <div class="carfax-header">
                       <img src="${badge.BadgesImageUrl}" alt="CarFax Badge" class="carfax-badge-main" 
                            onerror="this.style.display='none';">
                     </div>
                     <div class="carfax-content">
                       <h4>Vehicle History Report</h4>
                       <p><i class="ion-checkmark-circled"></i> Available - Click to view complete report</p>
                       <a href="${badge.VhrReportUrl}" target="_blank" class="carfax-btn">
                         <i class="ion-document-text"></i>
                         VIEW REPORT
                       </a>
                     </div>
                   </div>
                 </div>`;
        console.log('CarFax report link generated successfully');
      } else {
        console.warn('CarFax data available but report URL not found');
        cftmp = `<div class="carfax-professional">
                   <div class="carfax-card">
                     <div class="carfax-content">
                       <h4>Vehicle History Report</h4>
                       <p><i class="ion-document-text"></i> Available - Contact dealer for details</p>
                       <button class="carfax-btn-disabled">
                         <i class="ion-android-call"></i>
                         CONTACT FOR DETAILS
                       </button>
                     </div>
                   </div>
                 </div>`;
      }
    }
  } catch (error) {
    console.error('Error fetching CarFax report:', error);
    cftmp = `<div class="carfax-professional">
               <div class="carfax-card">
                 <div class="carfax-content">
                   <h4>Vehicle History Report</h4>
                   <p><i class="ion-alert-circled"></i> Temporarily unavailable</p>
                   <p class="carfax-note">Contact dealer for vehicle history details</p>
                 </div>
               </div>
             </div>`;
  } finally {
    // Always set content, even if empty
    const carFaxElement = document.querySelector('#carFaxData');
    if (carFaxElement) {
      carFaxElement.innerHTML = cftmp;
    }
  }
};

const generateSideBarDealerInfoData = async (di) => {
  let tpd = '';

  tpd += `<div class="dealer-profile">
<div class="profile-image">
    <img src="assets/images/author-5.jpg" alt="">
</div>
<div class="profile-content">
    <h5 class="name"><a href="#">Hansen Truck & Car Sales</a></h5>
    <div class="profile-rating">
        <ul class="star">
            <li class="rating-on"><i class="ion-android-star"></i></li>
            <li class="rating-on"><i class="ion-android-star"></i></li>
            <li class="rating-on"><i class="ion-android-star"></i></li>
            <li class="rating-on"><i class="ion-android-star"></i></li>
            <li><i class="ion-android-star"></i></li>
        </ul>
        <span>(${di.rating} Google Rating)</span>
    </div>
</div>
</div>
<ul class="info-items">
<li>
    <i class="ion-ios-location"></i>
        <span>${di.formatted_address}</span>
        <span></span>
</li>
<li>
    <i class="ion-ios-telephone"></i>
    <span><a class="call" href="tel:${di.formatted_phone_number}">${di.formatted_phone_number}</a></span>
</li>
<li>
    <i class="ion-android-mail"></i>
    <span><a
            href="mailto:hansentc@yahoo.ca">hansentc@yahoo.ca</a></span>
</li>

</ul>`;
  document.querySelector('#dealerInfo').innerHTML = tpd;
};

const sidebarRecentListings = async () => {
  let tprc = '';

  PageData.filter((s) => s.attributes.Status === 'Available')
    .slice(0, 10)
    .forEach((d) => {
      tprc += `<li>
        <div class="single-listing">
            <div class="listing-image">
                <a href="cardetail.html?id=${
                  d.id
                }&location=brampton&used-car-for-sale=${
        d.attributes.Year + ' ' + d.attributes.Make + ' ' + d.attributes.Model
      }">
                    <img src="${
                      imgServer +
                      d.attributes.Images.data.filter(
                        (i) => i.attributes.formats != null
                      )[0].attributes.formats.small.url
                    }" alt="">
                </a>
            </div>
            <div class="listing-content">
                <h2 class="title"><a href="cardetail.html?id=${
                  d.id
                }&location=brampton&used-car-for-sale=${
        d.attributes.Year + ' ' + d.attributes.Make + ' ' + d.attributes.Model
      }">${
        d.attributes.Year + ' ' + d.attributes.Make + ' ' + d.attributes.Model
      } </a></h2>
                <div class="price">
                    <span class="price-amount">${currencyFormatter.format(
                      d.attributes.Price
                    )}</span>
                </div>
            </div>
        </div>
    </li>`;
    });

  document.querySelector('#pageSidebarNewlyAdded').innerHTML = tprc;
};

// Enhanced slider initialization
const initializeImprovedSlider = () => {
  // Destroy existing sliders first
  if ($('.dealership-gallery-active').hasClass('slick-initialized')) {
    $('.dealership-gallery-active').slick('unslick');
  }
  if ($('.dealership-gallery-thumb-active').hasClass('slick-initialized')) {
    $('.dealership-gallery-thumb-active').slick('unslick');
  }

  // Initialize main gallery with improved settings
  $('.dealership-gallery-active').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    fade: false, // Changed from fade for better performance
    asNavFor: '.dealership-gallery-thumb-active',
    autoplay: false,
    dots: false,
    infinite: true,
    speed: 300,
    lazyLoad: 'ondemand',
    adaptiveHeight: true, // This helps with different aspect ratios
    prevArrow:
      '<div class="slick-prev"><i class="ion-ios-arrow-left"></i></div>',
    nextArrow:
      '<div class="slick-next"><i class="ion-ios-arrow-right"></i></div>',
    responsive: [
      {
        breakpoint: 768,
        settings: {
          arrows: true,
          adaptiveHeight: true,
        },
      },
    ],
  });

  // Initialize thumbnail gallery with improved settings
  $('.dealership-gallery-thumb-active').slick({
    slidesToShow: 6,
    slidesToScroll: 1,
    asNavFor: '.dealership-gallery-active',
    dots: false,
    arrows: true,
    centerMode: false,
    focusOnSelect: true,
    infinite: true,
    vertical: false,
    prevArrow:
      '<div class="slick-prev"><i class="ion-ios-arrow-left"></i></div>',
    nextArrow:
      '<div class="slick-next"><i class="ion-ios-arrow-right"></i></div>',
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 5,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 4,
          vertical: false,
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 3,
        },
      },
    ],
  });

  // Add custom event handlers for better UX
  $('.dealership-gallery-active').on(
    'afterChange',
    function (event, slick, currentSlide) {
      // Update thumbnail active state
      $('.single-dealership-thumb').removeClass('active-thumb');
      $(`.single-dealership-thumb[data-index="${currentSlide}"]`).addClass(
        'active-thumb'
      );
    }
  );

  // Handle thumbnail clicks
  $('.single-dealership-thumb').on('click', function () {
    const index = $(this).data('index');
    $('.dealership-gallery-active').slick('slickGoTo', index);
  });
};

// Image loading handlers
window.handleImageLoad = function (img) {
  img.classList.add('loaded');
  img.parentElement.classList.add('image-loaded');
};

window.handleImageError = function (img) {
  img.src = 'assets/images/no-image-placeholder.jpg'; // Add a placeholder image
  img.classList.add('error');
};

window.handleThumbLoad = function (img) {
  img.classList.add('thumb-loaded');
};

const generateBreadcrumbData = async () => {
  let tmp = '';
  tmp = `<li class="breadcrumb-item"><a href="index.html">Home</a></li>
         <li class="breadcrumb-item"><a href="inventory.html">Inventory</a></li>
         <li class="breadcrumb-item active">${
           CarData[0].attributes.Year +
           ' ' +
           CarData[0].attributes.Make +
           ' ' +
           CarData[0].attributes.Model
         }</li>`;

  document.querySelector('#breadcrumbData').innerHTML = tmp;
};

const generateTitleAndPrice = async () => {
  const car = CarData[0].attributes;
  const carInfo = `${car.Year} ${car.Make} ${car.Model}`;
  const isAvailable = car.Status === 'Available';

  let tmpt = '';
  tmpt += `
    <div class="row align-items-start mb-3">
      <div class="col-lg-6">
        <div class="vehicle-title-section">
          <h1 class="entry-title mb-3">${carInfo} For Sale in Brampton</h1>
          <div class="dealer-location mb-3">
            <i class="ion-android-pin text-primary me-2"></i> 
            <span>Available at Hansen Truck & Car Sales - Brampton, ON</span>
          </div>
          
          <div class="status-badges-row mb-3">
            ${
              isAvailable
                ? `
              <span class="status-badge available me-2">
                <i class="ion-checkmark-circled"></i> Available Now
              </span>
             
            `
                : '<span class="status-badge sold">SOLD</span>'
            }
          </div>
        </div>
      </div>
      
      <div class="col-lg-3">
        <div class="carfax-section" id="carFaxData">
          <!-- CarFax data will be inserted here -->
        </div>
      </div>
      
      <div class="col-lg-3">
        <div class="trust-logos-section">
          <div class="trust-logos-container">
            <img class="trust-logo-item ucda-logo" src="assets/images/UCDA_Member_Logo-1.gif" alt="UCDA Logo">
          </div>
        </div>
      </div>
    </div>
    
    <div class="row align-items-center">
      <div class="col-lg-3">
        <div class="price-section">
          <div class="main-price mb-2">
            <span class="sale-price">${
              car.Status === 'Sold' || car.Status === 'Inactive'
                ? 'SOLD'
                : currencyFormatter.format(car.Price)
            }</span>
          </div>
          ${
            isAvailable
              ? `
            <div class="price-details">
              <div class="tax-info">Plus taxes and fees</div>
              <div class="financing-info">Financing available</div>
            </div>
          `
              : ''
          }
        </div>
      </div>
      
      <div class="col-lg-6">
        <div class="service-area-compact">
          <div class="service-info-line">
            <i class="ion-location"></i>
            <span>Proudly Serving the Greater Toronto Area: Brampton • Mississauga • Caledon • Bolton • Vaughan • Etobicoke</span>
          </div>
          <div class="location-info-line">
            <i class="ion-navigate"></i>
            <span>Conveniently located near Highway 410 • Easy access from all GTA locations</span>
          </div>
        </div>
      </div>
      
      <div class="col-lg-3">
        <div class="trust-logos-section">
          <div class="trust-logos-container">
            <img class="trust-logo-item bbb-logo" src="assets/images/bbb-accredited-business.svg" alt="BBB Accredited Business">
          </div>
        </div>
      </div>
    </div>
  `;

  document.querySelector('#titlePriceData').innerHTML = tmpt;
};

const getFeaturesFromCarData = async () => {
  let tpl = '';
  if (CarData[0].attributes.Comfort != null) {
    tpl +=
      CarData[0].attributes.Comfort.AirConditioning == true
        ? '<li><i class="ion-checkmark-circled"></i> Air Conditioning</li>'
        : '';
    tpl +=
      CarData[0].attributes.Comfort.KeylessEntry == true
        ? '<li><i class="ion-checkmark-circled"></i> Keyless Entry</li>'
        : '';
    tpl +=
      CarData[0].attributes.Comfort.SteeringWheelControls == true
        ? '<li><i class="ion-checkmark-circled"></i> Steering Wheel Controls</li>'
        : '';
    tpl +=
      CarData[0].attributes.Comfort.SunroofMonroof == true
        ? '<li><i class="ion-checkmark-circled"></i> Sunroof/Monroof</li>'
        : '';
    tpl +=
      CarData[0].attributes.Comfort.TiltSteeringWheel == true
        ? '<li><i class="ion-checkmark-circled"></i> Tilt Steering Wheel</li>'
        : '';
  }
  if (CarData[0].attributes.Convenience != null) {
    tpl +=
      CarData[0].attributes.Convenience.AllowWheels == true
        ? '<li><i class="ion-checkmark-circled"></i> Allow Wheels</li>'
        : '';
    tpl +=
      CarData[0].attributes.Convenience.AppleCarPlay == true
        ? '<li><i class="ion-checkmark-circled"></i> Apple Car Play</li>'
        : '';
    tpl +=
      CarData[0].attributes.Convenience.BackupCamera == true
        ? '<li><i class="ion-checkmark-circled"></i> Backup Camera</li>'
        : '';
    tpl +=
      CarData[0].attributes.Convenience.HeatedSeats == true
        ? '<li><i class="ion-checkmark-circled"></i> Heated Seats</li>'
        : '';
    tpl +=
      CarData[0].attributes.Convenience.HeatedSteeringWheel == true
        ? '<li><i class="ion-checkmark-circled"></i> Heated Steering Wheel </li>'
        : '';
    tpl +=
      CarData[0].attributes.Convenience.Navigation == true
        ? '<li><i class="ion-checkmark-circled"></i> Navigation</li>'
        : '';
    tpl +=
      CarData[0].attributes.Convenience.PanoramicSunroof == true
        ? '<li><i class="ion-checkmark-circled"></i> Panoramic Sunroof</li>'
        : '';
    tpl +=
      CarData[0].attributes.Convenience.VentilatedSeats == true
        ? '<li><i class="ion-checkmark-circled"></i> Ventilated Seats</li>'
        : '';
    tpl +=
      CarData[0].attributes.Convenience.WinterTires == true
        ? '<li><i class="ion-checkmark-circled"></i> Winter Tires</li>'
        : '';
  }
  if (CarData[0].attributes.Exterior != null) {
    tpl +=
      CarData[0].attributes.Exterior.AlloyWheels == true
        ? '<li><i class="ion-checkmark-circled"></i> Alloy Wheels</li>'
        : '';
    tpl +=
      CarData[0].attributes.Exterior.Spoiler == true
        ? '<li><i class="ion-checkmark-circled"></i> Spoiler</li>'
        : '';
    tpl +=
      CarData[0].attributes.Exterior.TintedGlass == true
        ? '<li><i class="ion-checkmark-circled"></i> Tinted Glass</li>'
        : '';
    tpl +=
      CarData[0].attributes.Exterior.TrailerHitch == true
        ? '<li><i class="ion-checkmark-circled"></i> Trailer Hitch</li>'
        : '';
    tpl +=
      CarData[0].attributes.Exterior.WinterTires == true
        ? '<li><i class="ion-checkmark-circled"></i> Winter Tires</li>'
        : '';
  }
  if (CarData[0].attributes.MediaNavComm != null) {
    tpl +=
      CarData[0].attributes.MediaNavComm.AMFMCassette == true
        ? '<li><i class="ion-checkmark-circled"></i> AM/FM Cassette</li>'
        : '';
    tpl +=
      CarData[0].attributes.MediaNavComm.AMFMCDPlayer == true
        ? '<li><i class="ion-checkmark-circled"></i> AM/FM CD Player</li>'
        : '';
    tpl +=
      CarData[0].attributes.MediaNavComm.AMFMRadio == true
        ? '<li><i class="ion-checkmark-circled"></i> AM/FM Radio</li>'
        : '';
    tpl +=
      CarData[0].attributes.MediaNavComm.CDChanger == true
        ? '<li><i class="ion-checkmark-circled"></i> CD Changer</li>'
        : '';
    tpl +=
      CarData[0].attributes.MediaNavComm.DVDEntertainment == true
        ? '<li><i class="ion-checkmark-circled"></i> DVD Entertainment</li>'
        : '';
    tpl +=
      CarData[0].attributes.MediaNavComm.GPSNavigation == true
        ? '<li><i class="ion-checkmark-circled"></i> GPS Navigation</li>'
        : '';
    tpl +=
      CarData[0].attributes.MediaNavComm.PremiumSoundSystem == true
        ? '<li><i class="ion-checkmark-circled"></i> Premium Sound System</li>'
        : '';
  }
  if (CarData[0].attributes.PowerOptions != null) {
    tpl +=
      CarData[0].attributes.PowerOptions.PowerDoorLocks == true
        ? '<li><i class="ion-checkmark-circled"></i> Power Door Locks</li>'
        : '';
    tpl +=
      CarData[0].attributes.PowerOptions.PowerMirrors == true
        ? '<li><i class="ion-checkmark-circled"></i> Power Mirrors</li>'
        : '';
    tpl +=
      CarData[0].attributes.PowerOptions.PowerSeats == true
        ? '<li><i class="ion-checkmark-circled"></i> Power Seats</li>'
        : '';
    tpl +=
      CarData[0].attributes.PowerOptions.PowerSlidingDoors == true
        ? '<li><i class="ion-checkmark-circled"></i> Power Sliding Doors</li>'
        : '';
    tpl +=
      CarData[0].attributes.PowerOptions.PowerSteering == true
        ? '<li><i class="ion-checkmark-circled"></i> Power Steering</li>'
        : '';
    tpl +=
      CarData[0].attributes.PowerOptions.PowerTrunk == true
        ? '<li><i class="ion-checkmark-circled"></i> Power Trunk</li>'
        : '';
    tpl +=
      CarData[0].attributes.PowerOptions.PowerWindows == true
        ? '<li><i class="ion-checkmark-circled"></i> Power Windows</li>'
        : '';
  }
  if (CarData[0].attributes.Safety != null) {
    tpl +=
      CarData[0].attributes.Safety.AntiLockBrakes == true
        ? '<li><i class="ion-checkmark-circled"></i> Anti-Lock Brakes</li>'
        : '';
    tpl +=
      CarData[0].attributes.Safety.AntiTheftSystem == true
        ? '<li><i class="ion-checkmark-circled"></i> Anti-Theft System</li>'
        : '';
    tpl +=
      CarData[0].attributes.Safety.ChildSeatAnchors == true
        ? '<li><i class="ion-checkmark-circled"></i> Child Seat Anchors</li>'
        : '';
    tpl +=
      CarData[0].attributes.Safety.DriverAirBag == true
        ? '<li><i class="ion-checkmark-circled"></i> Driver Air Bag</li>'
        : '';
    tpl +=
      CarData[0].attributes.Safety.FogLights == true
        ? '<li><i class="ion-checkmark-circled"></i> Fog Lights</li>'
        : '';
    tpl +=
      CarData[0].attributes.Safety.HeatedMirrors == true
        ? '<li><i class="ion-checkmark-circled"></i> Heated Mirrors</li>'
        : '';
    tpl +=
      CarData[0].attributes.Safety.PassengerAirBag == true
        ? '<li><i class="ion-checkmark-circled"></i> Passenger Air Bag</li>'
        : '';
    tpl +=
      CarData[0].attributes.Safety.RearWindowDefrost == true
        ? '<li><i class="ion-checkmark-circled"></i> Rear Window Defrost</li>'
        : '';
    tpl +=
      CarData[0].attributes.Safety.SecuritySystem == true
        ? '<li><i class="ion-checkmark-circled"></i> Security System</li>'
        : '';
    tpl +=
      CarData[0].attributes.Safety.SideAirBag == true
        ? '<li><i class="ion-checkmark-circled"></i> Side Air Bag</li>'
        : '';
    tpl +=
      CarData[0].attributes.Safety.TractionControl == true
        ? '<li><i class="ion-checkmark-circled"></i> Traction Control</li>'
        : '';
  }
  if (CarData[0].attributes.Seating != null) {
    tpl +=
      CarData[0].attributes.Seating.BucketSeats == true
        ? '<li><i class="ion-checkmark-circled"></i> Bucket Seats</li>'
        : '';
    tpl +=
      CarData[0].attributes.Seating.FoldingRearSeat == true
        ? '<li><i class="ion-checkmark-circled"></i> Folding Rear Seat</li>'
        : '';
    tpl +=
      CarData[0].attributes.Seating.HeatedSeats == true
        ? '<li><i class="ion-checkmark-circled"></i> Heated Seats</li>'
        : '';
    tpl +=
      CarData[0].attributes.Seating.LeatherSeats == true
        ? '<li><i class="ion-checkmark-circled"></i> Leather Seats</li>'
        : '';
    tpl +=
      CarData[0].attributes.Seating.LumbarSupport == true
        ? '<li><i class="ion-checkmark-circled"></i> Lumbar Support</li>'
        : '';
    tpl +=
      CarData[0].attributes.Seating.QuadsCaptains == true
        ? '<li><i class="ion-checkmark-circled"></i> Quads Captains</li>'
        : '';
    tpl +=
      CarData[0].attributes.Seating.SplitRearSeat == true
        ? '<li><i class="ion-checkmark-circled"></i> Split Rear Seat</li>'
        : '';
  }
  if (CarData[0].attributes.Warranty != null) {
    tpl +=
      CarData[0].attributes.Warranty.BalanceOfFactoryWarranty == true
        ? '<li><i class="ion-checkmark-circled"></i> Balance Of Factory Warranty</li>'
        : '';
    tpl +=
      CarData[0].attributes.Warranty.WarrantyAvailable == true
        ? '<li><i class="ion-checkmark-circled"></i> Warranty Available</li>'
        : '';
    tpl +=
      CarData[0].attributes.Warranty.WarrantyIncluded == true
        ? '<li><i class="ion-checkmark-circled"></i> Warranty Included</li>'
        : '';
  }

  return tpl;
};

const generateOtherDetailData = async () => {
  let tmp = '';
  tmp = ` 
   
    <div class="specifications">
                <h5 class="singe-title">technical specifications</h5>

        <div class="specifications-wrapper">
            <div class="row">
                <div class="col-md-3 col-sm-4 col-6 glance-col">
                    <span class="glance">
                        <i class="ion-android-car"></i> 
                        <span class="label">Body</span>
                        <span class="value">${
                          CarData[0].attributes.Category
                        }</span>
                    </span>
                </div>
                <div class="col-md-3 col-sm-4 col-6 glance-col">
                    <span class="glance">
                        <i class="ion-gear-a"></i> 
                        <span class="label">Drive</span>
                        <span class="value">${
                          CarData[0].attributes.Driveline
                        } </span>
                    </span>
                </div>
                <div class="col-md-3 col-sm-4 col-6 glance-col">
                    <span class="glance">
                        <i class="ion-map"></i> 
                        <span class="label">mileage</span>
                        <span class="value">${
                          CarData[0].attributes.Odometer
                        } km</span>
                    </span>
                </div>
                <div class="col-md-3 col-sm-4 col-6 glance-col">
                    <span class="glance">
                        <i class="ion-waterdrop"></i> 
                        <span class="label">Fuel Type</span>
                        <span class="value">${
                          CarData[0].attributes.FuelType
                        } </span>
                    </span>
                </div>
                <div class="col-md-3 col-sm-4 col-6 glance-col">
                    <span class="glance">
                        <i class="ion-speedometer"></i> 
                        <span class="label">transmission</span>
                        <span class="value">${
                          CarData[0].attributes.Transmission
                        }</span>
                    </span>
                </div>
                <div class="col-md-3 col-sm-4 col-6 glance-col">
                    <span class="glance">
                        <i class="ion-ios-cog-outline"></i> 
                        <span class="label">Engine</span>
                        <span class="value">${
                          CarData[0].attributes.Engine.includes('Cylinder')
                            ? CarData[0].attributes.Engine.substring(8) +
                              '-Cylinder'
                            : CarData[0].attributes.Engine
                        } </span>
                    </span>
                </div>
                <div class="col-md-3 col-sm-4 col-6 glance-col">
                    <span class="glance">
                        <i class="ion-contrast"></i> 
                        <span class="label">exterior col...</span>
                        <span class="value">${
                          CarData[0].attributes.ExteriorColor
                        } </span>
                    </span>
                </div>
                <div class="col-md-3 col-sm-4 col-6 glance-col">
                    <span class="glance">
                        <i class="ion-contrast"></i> 
                        <span class="label">Interior Col...</span>
                        <span class="value">${
                          CarData[0].attributes.InteriorColor
                        }</span>
                    </span>
                </div>
                <div class="col-md-3 col-sm-4 col-6 glance-col">
                    <span class="glance">
                        <span class="icon">&copy;</span>
                        <span class="label">Year</span>
                        <span class="value">${CarData[0].attributes.Year}</span>
                    </span>
                </div>
                <div class="col-md-3 col-sm-4 col-6 glance-col">
                    <span class="glance">
                        <i class="ion-pricetag"></i> 
                        <span class="label">Doors</span>
                        <span class="value">${
                          CarData[0].attributes.Doors
                        }</span>
                    </span>
                </div>
                <div class="col-md-3 col-sm-4 col-6 glance-col">
                    <span class="glance">
                        <i class="ion-android-calendar"></i> 
                        <span class="label">Trim</span>
                        <span class="value">${CarData[0].attributes.Trim}</span>
                    </span>
                </div>
                <div class="col-md-3 col-sm-4 col-6 glance-col">
                    <span class="glance">
                        <i class="ion-clipboard"></i> 
                        <span class="label">VIN:</span>
                        <span class="value">${CarData[0].attributes.VIN}</span>
                    </span>
                </div>
            </div>
        </div>
    </div>


<div class="overview">

    <p>${
      CarData[0].attributes.Description != null
        ? CarData[0].attributes.Description
        : ''
    }</p>
</div>

<div class="features">
    <h5 class="singe-title">features & options</h5>

    <ul class="features-list">
    ${await getFeaturesFromCarData()}
        
    </ul>
</div>






<div class="features-car">
    <h5 class="singe-title">more vehicles by <a href="inventory.html">Hansen Truck & Car Sales</a></h5>
   
    <div class="row car-row cars-active-3">
         ${await getInventory()}
        
        
    </div>
</div>

<div class="consumer-reviews">
                            <h5 class="singe-title">What our customers say on Google</h5>

                        

                            <div class="reviews-comment">
                                <ul class="reviews-comments-items">

                                ${await buildTestimonials()}
                                </ul>

                            </div>

                        
</div
`;

  document.querySelector('#detailData').innerHTML = tmp;
};

const googlePlaceData = async () => {
  const data = await googlePlaceDataAPI();
  console.log('🚀 ~ file: main.js ~ line 162 ~ googlePlaceData ~ data', data);
  return data;
};

const generateTPL_MessageSubmitted = () => {
  var tpl = `<div class="row col-sm-12"><h3 class="text-dark">Message Sent!</h3> </div>
      <div class="row col-sm-12"><p class="lead font-weight-bold mb-4 mb-md-5">Thank you for reaching out ${
        document.querySelector('#testDrive_Name').value
      }. We will get back to you.</p></div>`;
  document.querySelector('#hansen_testDriveForm').innerHTML = tpl;
};

const submitContactForm = async (token) => {
  console.log('submit test drive form from the car detail page');
  let contactInfo = {};
  contactInfo.token = token;
  contactInfo.FullName = document.querySelector('#testDrive_Name').value;
  contactInfo.Email = document.querySelector('#testDrive_Email').value;
  contactInfo.Phone = document.querySelector('#testDrive_Phone').value;
  contactInfo.BestDay = document.querySelector('#testDrive_BestDay').value;
  contactInfo.BestTime = document.querySelector('#testDrive_BestTime').value;
  contactInfo.CarLink = window.location.href;

  breq
    .post('TestDrive/TestDriveAsync', JSON.stringify(contactInfo))
    .then((res) => {
      console.log(res);
      generateTPL_MessageSubmitted();
    });
};

document
  .querySelector('#hansen_testDriveForm')
  .addEventListener('submit', async (e) => {
    e.preventDefault();

    grecaptcha.ready(function () {
      grecaptcha
        .execute('6LcJjOEiAAAAAIe7TA3cT8nT-xMZXKKBFtbaDrs4', {
          action: 'submit',
        })
        .then(async function (token) {
          // Add your logic to submit to  backend server.

          await submitContactForm(token);
        });
    });
  });

const loadJavascriptNow = async () => {
  const script = document.createElement('script');
  script.src = 'assets/js/main.js';

  // Append to the `head` element
  document.head.appendChild(script);
};

// PhotoSwipe 5 Implementation for Car Gallery
// Replace your existing generateSlider function with this enhanced version

let photoSwipeLightbox = null; // Global variable to store PhotoSwipe instance

const generateSlider = async () => {
  let tmpl = '';
  let tmpl_thumb = '';
  let photoSwipeItems = []; // Array to store PhotoSwipe gallery items

  // Filter and process images
  const images = CarData[0].attributes.Images.data.filter(
    (i) => i.attributes.formats != null
  );

  if (images.length === 0) {
    // Handle case with no images
    const placeholderHtml = createNoImagePlaceholder();
    document.querySelector('#pageSliderData').innerHTML = placeholderHtml;
    document.querySelector('#pageSliderThumb').innerHTML = '';
    return;
  }

  // Generate HTML and PhotoSwipe data
  images.forEach((e, index) => {
    // Determine the best image sizes for different purposes
    const originalImage = e.attributes;
    const largeImage =
      originalImage.formats.large ||
      originalImage.formats.medium ||
      originalImage;
    const mediumImage =
      originalImage.formats.medium ||
      originalImage.formats.large ||
      originalImage;
    const thumbImage =
      originalImage.formats.thumbnail ||
      originalImage.formats.small ||
      originalImage;

    // Generate SEO-optimized alt text based on image position
    const generateSEOAltText = (index, originalAlt) => {
      if (originalAlt) return originalAlt;

      const carInfo = `${CarData[0].attributes.Year} ${CarData[0].attributes.Make} ${CarData[0].attributes.Model}`;
      const imageTypes = [
        'exterior front view',
        'exterior rear view',
        'interior dashboard',
        'interior seating',
        'driver side view',
        'passenger side view',
        'engine bay',
        'trunk/cargo area',
        'wheel/tire closeup',
        'interior technology',
        'exterior detail',
        'interior detail',
      ];

      const imageType = imageTypes[index] || `view ${index + 1}`;
      return `${carInfo} ${imageType} - Hansen Truck & Car Sales Brampton used car dealer`;
    };

    // PhotoSwipe requires exact dimensions for proper functionality
    const seoAltText = generateSEOAltText(index, originalImage.alternativeText);

    const photoSwipeItem = {
      src: imgServer + originalImage.url,
      width: originalImage.width,
      height: originalImage.height,
      alt: seoAltText,
      caption:
        originalImage.caption ||
        `${CarData[0].attributes.Year} ${CarData[0].attributes.Make} ${CarData[0].attributes.Model} available at Hansen Truck & Car Sales`,
    };

    photoSwipeItems.push(photoSwipeItem);

    // Generate main slider HTML with PhotoSwipe attributes
    tmpl += `
      <div class="single-dealership-gallery">
        <a href="${imgServer + originalImage.url}" 
           data-pswp-width="${originalImage.width}" 
           data-pswp-height="${originalImage.height}"
           data-pswp-index="${index}"
           class="pswp-gallery-item"
           title="${seoAltText}">
          <div class="image-container">
            <img src="${imgServer + mediumImage.url}" 
                 alt="${seoAltText}"
                 title="${seoAltText}"
                 data-index="${index}"
                 onload="handleImageLoad(this)"
                 onerror="handleImageError(this, '${
                   imgServer + originalImage.url
                 }')">
          </div>
        </a>
      </div>`;

    // Generate thumbnail HTML with SEO-optimized alt text
    const thumbAltText = `${CarData[0].attributes.Year} ${
      CarData[0].attributes.Make
    } ${CarData[0].attributes.Model} thumbnail ${index + 1}`;
    tmpl_thumb += `
      <div class="thumb-col">
        <div class="single-dealership-thumb" data-index="${index}">
          <img src="${imgServer + thumbImage.url}" 
               alt="${thumbAltText}"
               title="${thumbAltText}"
               onload="handleThumbLoad(this)">
        </div>
      </div>`;
  });

  // Insert HTML into DOM
  document.querySelector('#pageSliderData').innerHTML = tmpl;
  document.querySelector('#pageSliderThumb').innerHTML = tmpl_thumb;

  // Initialize PhotoSwipe and Slick slider with loading check
  setTimeout(() => {
    waitForPhotoSwipe().then(() => {
      initializePhotoSwipeGallery(photoSwipeItems);
      initializeSlickSlider();
    });
  }, 100);
};

// Wait for PhotoSwipe to load with retry mechanism
const waitForPhotoSwipe = () => {
  return new Promise((resolve) => {
    let attempts = 0;
    const maxAttempts = 50; // 5 seconds total

    const checkPhotoSwipe = () => {
      attempts++;

      if (
        typeof PhotoSwipeLightbox !== 'undefined' &&
        typeof PhotoSwipe !== 'undefined'
      ) {
        window.PhotoSwipeAvailable = true;
        console.log('PhotoSwipe loaded successfully');
        resolve();
      } else if (attempts >= maxAttempts) {
        window.PhotoSwipeAvailable = false;
        console.warn(
          'PhotoSwipe failed to load after 5 seconds, using fallback'
        );
        resolve();
      } else {
        setTimeout(checkPhotoSwipe, 100);
      }
    };

    checkPhotoSwipe();
  });
};

// Initialize PhotoSwipe 5 Gallery
const initializePhotoSwipeGallery = (items) => {
  // Check if PhotoSwipe is available
  if (
    !window.PhotoSwipeAvailable ||
    typeof PhotoSwipeLightbox === 'undefined'
  ) {
    console.warn('PhotoSwipe not available, using basic lightbox fallback');
    initializeFallbackLightbox();
    return;
  }

  // Destroy existing instance if it exists
  if (photoSwipeLightbox) {
    photoSwipeLightbox.destroy();
  }

  // Create new PhotoSwipe Lightbox instance
  photoSwipeLightbox = new PhotoSwipeLightbox({
    gallery: '#pageSliderData',
    children: '.pswp-gallery-item',

    // PhotoSwipe options
    pswpModule: PhotoSwipe,

    // UI options
    showHideAnimationType: 'zoom',
    bgOpacity: 0.8,

    // Zoom options
    maxZoomLevel: 3,
    zoom: true,

    // UI elements
    closeTitle: 'Close (Esc)',
    zoomTitle: 'Zoom in/out',
    arrowPrevTitle: 'Previous (arrow left)',
    arrowNextTitle: 'Next (arrow right)',

    // Additional options for better UX
    wheelToZoom: true,
    pinchToClose: false,
    closeOnVerticalDrag: true,

    // Error handling
    errorMsg: 'The image could not be loaded.',

    // Spacing around images
    spacing: 0.1,

    // Initial zoom level
    initialZoomLevel: 'fit',
    secondaryZoomLevel: 2,
    maxZoomLevel: 3,

    // Custom data source function
    dataSource: items,
  });

  // Add custom event listeners
  photoSwipeLightbox.on('uiRegister', function () {
    // Add custom UI elements if needed
    // Add image title/caption
  });

  // Sync with Slick slider when PhotoSwipe changes slides
  photoSwipeLightbox.on('change', () => {
    const currentIndex = photoSwipeLightbox.pswp.currIndex;
    syncSlickSlider(currentIndex);
  });

  // Handle opening from thumbnail clicks
  photoSwipeLightbox.on('beforeOpen', (e) => {
    // Custom logic before opening if needed
    console.log('PhotoSwipe opening...');
  });

  // Initialize the lightbox
  photoSwipeLightbox.init();
};

// ENHANCED SLICK SLIDER INITIALIZATION WITH PROPER ARROWS
const initializeSlickSlider = () => {
  console.log('Initializing Slick sliders...');

  // Destroy existing sliders first
  if ($('.dealership-gallery-active').hasClass('slick-initialized')) {
    $('.dealership-gallery-active').slick('unslick');
  }
  if ($('.dealership-gallery-thumb-active').hasClass('slick-initialized')) {
    $('.dealership-gallery-thumb-active').slick('unslick');
  }

  // Wait a moment for DOM to be ready
  setTimeout(() => {
    // Initialize main gallery slider with custom arrows
    $('.dealership-gallery-active').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      fade: false,
      asNavFor: '.dealership-gallery-thumb-active',
      autoplay: false,
      dots: false,
      infinite: true,
      speed: 300,
      adaptiveHeight: false, // Changed to false for better mobile experience
      prevArrow:
        '<button type="button" class="slick-prev custom-arrow"><i class="ion-ios-arrow-left"></i></button>',
      nextArrow:
        '<button type="button" class="slick-next custom-arrow"><i class="ion-ios-arrow-right"></i></button>',
      responsive: [
        {
          breakpoint: 768,
          settings: {
            arrows: true,
            adaptiveHeight: false,
          },
        },
        {
          breakpoint: 576,
          settings: {
            arrows: true,
            adaptiveHeight: false,
          },
        },
      ],
    });

    // Initialize thumbnail slider
    $('.dealership-gallery-thumb-active').slick({
      slidesToShow: 6,
      slidesToScroll: 1,
      asNavFor: '.dealership-gallery-active',
      dots: false,
      arrows: true,
      centerMode: false,
      focusOnSelect: true,
      infinite: true,
      prevArrow:
        '<button type="button" class="slick-prev custom-thumb-arrow"><i class="ion-ios-arrow-left"></i></button>',
      nextArrow:
        '<button type="button" class="slick-next custom-thumb-arrow"><i class="ion-ios-arrow-right"></i></button>',
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 5,
            arrows: true,
          },
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 4,
            arrows: true,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 4,
            arrows: true,
          },
        },
        {
          breakpoint: 576,
          settings: {
            slidesToShow: 3,
            arrows: true,
          },
        },
      ],
    });

    // Force arrow styling after initialization
    setTimeout(() => {
      styleCustomArrows();
    }, 100);

    console.log('Slick sliders initialized with custom arrows');
  }, 200);

  // Handle thumbnail clicks for PhotoSwipe
  $(document).on('click', '.single-dealership-thumb', function (e) {
    e.preventDefault();
    const index = parseInt($(this).data('index'));

    if (
      window.photoSwipeLightbox &&
      typeof PhotoSwipeLightbox !== 'undefined'
    ) {
      window.photoSwipeLightbox.loadAndOpen(index);
    } else {
      // Fallback: trigger gallery item click
      $(`.pswp-gallery-item[data-pswp-index="${index}"]`).trigger('click');
    }
  });

  // Update active thumbnail when main slider changes
  $('.dealership-gallery-active').on(
    'afterChange',
    function (event, slick, currentSlide) {
      updateActiveThumbnail(currentSlide);
    }
  );
};

// Function to properly style custom arrows
const styleCustomArrows = () => {
  // Style main gallery arrows
  $('.dealership-gallery-active .custom-arrow').css({
    position: 'absolute',
    top: '50%',
    transform: 'translateY(-50%)',
    'z-index': '10',
    width: '50px',
    height: '50px',
    background: 'rgba(0, 0, 0, 0.7)',
    color: '#fff',
    border: 'none',
    'border-radius': '50%',
    cursor: 'pointer',
    'font-size': '20px',
    display: 'flex',
    'align-items': 'center',
    'justify-content': 'center',
    transition: 'all 0.3s ease',
  });

  $('.dealership-gallery-active .slick-prev.custom-arrow').css({
    left: '20px',
    right: 'auto',
  });

  $('.dealership-gallery-active .slick-next.custom-arrow').css({
    right: '20px',
    left: 'auto',
  });

  // Style thumbnail arrows
  $('.dealership-gallery-thumb-active .custom-thumb-arrow').css({
    position: 'absolute',
    top: '50%',
    transform: 'translateY(-50%)',
    'z-index': '5',
    width: '30px',
    height: '30px',
    background: 'rgba(255, 255, 255, 0.9)',
    color: '#000',
    border: 'none',
    'border-radius': '50%',
    cursor: 'pointer',
    'font-size': '14px',
    display: 'flex',
    'align-items': 'center',
    'justify-content': 'center',
    transition: 'all 0.3s ease',
  });

  $('.dealership-gallery-thumb-active .slick-prev.custom-thumb-arrow').css({
    left: '10px',
    right: 'auto',
  });

  $('.dealership-gallery-thumb-active .slick-next.custom-thumb-arrow').css({
    right: '10px',
    left: 'auto',
  });

  // Add hover effects
  $('.custom-arrow').hover(
    function () {
      $(this).css('background', 'rgba(246, 155, 65, 0.9)');
    },
    function () {
      $(this).css('background', 'rgba(0, 0, 0, 0.7)');
    }
  );

  $('.custom-thumb-arrow').hover(
    function () {
      $(this).css({
        background: '#F69B41',
        color: '#fff',
      });
    },
    function () {
      $(this).css({
        background: 'rgba(255, 255, 255, 0.9)',
        color: '#000',
      });
    }
  );

  // Mobile arrow adjustments
  if (window.innerWidth <= 768) {
    $('.dealership-gallery-active .custom-arrow').css({
      width: '40px',
      height: '40px',
      'font-size': '16px',
    });

    $('.dealership-gallery-active .slick-prev.custom-arrow').css(
      'left',
      '10px'
    );
    $('.dealership-gallery-active .slick-next.custom-arrow').css(
      'right',
      '10px'
    );
  }
};

// Sync Slick slider with PhotoSwipe
const syncSlickSlider = (index) => {
  if ($('.dealership-gallery-active').hasClass('slick-initialized')) {
    $('.dealership-gallery-active').slick('slickGoTo', index, true);
  }
  updateActiveThumbnail(index);
};

// Update active thumbnail
const updateActiveThumbnail = (index) => {
  $('.single-dealership-thumb').removeClass('active-thumb');
  $(`.single-dealership-thumb[data-index="${index}"]`).addClass('active-thumb');
};
// Enhanced image loading handlers
window.handleImageLoad = function (img) {
  img.style.opacity = '1';
  img.classList.add('loaded');
  img.parentElement.classList.add('image-loaded');
};

window.handleImageError = function (img, fallbackSrc) {
  console.warn('Image failed to load, trying fallback:', img.src);

  // Try fallback URL
  if (fallbackSrc && img.src !== fallbackSrc) {
    img.src = fallbackSrc;
    return;
  }

  // Create SVG placeholder if all else fails
  const placeholder = createImagePlaceholder(800, 600, 'Image Not Available');
  img.src = placeholder;
  img.classList.add('error-image');
};

window.handleThumbLoad = function (img) {
  img.style.opacity = '1';
  img.classList.add('thumb-loaded');
};

// Create SVG placeholder for missing images
const createImagePlaceholder = (
  width = 800,
  height = 600,
  text = 'Car Image'
) => {
  const svg = `
    <svg width="${width}" height="${height}" xmlns="http://www.w3.org/2000/svg">
      <rect width="100%" height="100%" fill="#f8f9fa"/>
      <rect x="50%" y="40%" width="40" height="40" fill="#dee2e6" transform="translate(-20, -20)"/>
      <rect x="50%" y="40%" width="24" height="16" rx="2" fill="white" transform="translate(-12, -8)"/>
      <circle cx="50%" cy="32%" r="3" fill="#dee2e6"/>
      <text x="50%" y="65%" text-anchor="middle" font-family="Arial, sans-serif" 
            font-size="16" fill="#6c757d">${text}</text>
    </svg>
  `;

  return 'data:image/svg+xml;base64,' + btoa(svg);
};

// Create placeholder HTML for when no images are available
const createNoImagePlaceholder = () => {
  const placeholderSrc = createImagePlaceholder(
    800,
    600,
    'No Images Available'
  );
  return `
    <div class="single-dealership-gallery">
      <div class="image-container no-images">
        <img src="${placeholderSrc}" alt="No images available">
        <div class="no-images-text">
          <h4>No Images Available</h4>
          <p>Images for this vehicle are currently not available.</p>
        </div>
      </div>
    </div>`;
};

// Create placeholder for inventory items
const createInventoryPlaceholder = () => {
  const svg = `
    <svg width="400" height="230" xmlns="http://www.w3.org/2000/svg">
      <rect width="100%" height="100%" fill="#f8f9fa"/>
      <rect x="50%" y="40%" width="60" height="60" fill="#dee2e6" transform="translate(-30, -30)"/>
      <rect x="50%" y="40%" width="36" height="24" rx="2" fill="white" transform="translate(-18, -12)"/>
      <circle cx="50%" cy="32%" r="4" fill="#dee2e6"/>
      <text x="50%" y="70%" text-anchor="middle" font-family="Arial, sans-serif" 
            font-size="14" fill="#6c757d">Car Image</text>
    </svg>
  `;
  return 'data:image/svg+xml;base64,' + btoa(svg);
};

// Handle inventory image errors
window.handleInventoryImageError = function (img) {
  console.warn('Inventory image failed to load:', img.src);
  img.src = createInventoryPlaceholder();
  img.classList.add('error-placeholder');
};

// Update inventory image handling for consistency
const getInventory = async () => {
  let tpi = '';

  console.log('Building inventory with image fixes...');

  const availableCars = PageData.filter(
    (x) =>
      x.attributes.Make == CarData[0].attributes.Make &&
      x.attributes.Status === 'Available'
  );

  availableCars.forEach((d) => {
    // Enhanced image handling for inventory
    const inventoryImages = d.attributes.Images.data.filter(
      (i) => i.attributes.formats != null
    );

    let imageUrl = '';
    let imageAlt = `${d.attributes.Year} ${d.attributes.Make} ${d.attributes.Model}`;

    if (inventoryImages.length > 0) {
      const bestImage = inventoryImages[0].attributes;
      // Prefer medium size for inventory display
      imageUrl =
        bestImage.formats.medium?.url ||
        bestImage.formats.small?.url ||
        bestImage.url;
    } else {
      // Use placeholder if no images
      imageUrl = createInventoryPlaceholder();
    }

    tpi += `<div class="car-col col-lg-3">
        <div class="single-car-item-2 mt-50">
            <div class="car-image">
                <a href="cardetail.html?id=${
                  d.id
                }&location=brampton&used-car-for-sale=${
      d.attributes.Year + ' ' + d.attributes.Make + ' ' + d.attributes.Model
    }">
                    <img src="${imgServer + imageUrl}"
                         alt="${imageAlt}"
                         class="inventory-img"
                         onload="this.classList.add('loaded')"
                         onerror="handleInventoryImageError(this)">
                </a>
                <ul class="car-meta">
                    <li>
                        <button type="button">
                            <i class="ion-arrow-expand"></i>
                            <span class="car-tooltip View">Quick View</span>
                        </button>
                    </li>
                </ul>
                ${
                  d.attributes.Flag == null
                    ? ''
                    : '<span class="status special"><i class="ion-flash"></i>' +
                      d.attributes.Flag +
                      '</span>'
                }
            </div>
            <div class="car-content">
                <span class="price">
                    <span class="sale-price">${currencyFormatter.format(
                      d.attributes.Price
                    )}</span>
                </span>
                <span class="body-type"><a href="#">${
                  d.attributes.Category
                }</a></span>
                <h4 class="car-title"><a href="cardetail.html?id=${
                  d.id
                }&location=brampton&used-car-for-sale=${
      d.attributes.Year + ' ' + d.attributes.Make + ' ' + d.attributes.Model
    }"> ${
      d.attributes.Year + ' ' + d.attributes.Make + ' ' + d.attributes.Model
    }</a></h4>
                <ul class="car-meta">
                    <li><a href="#"><i class="ion-speedometer"></i> ${
                      d.attributes.Transmission
                    }</a></li>
                    <li><a href="#"><i class="ion-android-settings"></i> ${
                      d.attributes.Driveline
                    }</a></li>
                    <li><a href="#"><i class="ion-map"></i> ${
                      d.attributes.Odometer
                    } km</a></li>
                </ul>
            </div>
        </div>
    </div>`;
  });

  console.log(`Generated ${availableCars.length} inventory items`);
  return tpi;
};

// Force refresh sliders on window resize
$(window).on('resize', function () {
  clearTimeout(window.resizeTimer);
  window.resizeTimer = setTimeout(() => {
    if ($('.dealership-gallery-active').hasClass('slick-initialized')) {
      $('.dealership-gallery-active').slick('refresh');
    }
    if ($('.dealership-gallery-thumb-active').hasClass('slick-initialized')) {
      $('.dealership-gallery-thumb-active').slick('refresh');
    }
    styleCustomArrows();
  }, 250);
});

// SEO Metadata Generation Function
const generateSEOMetadata = async () => {
  const car = CarData[0].attributes;
  const carYear = car.Year;
  const carMake = car.Make;
  const carModel = car.Model;
  const carPrice = car.Price;
  const carMileage = car.Odometer || 'Low mileage';
  const carTransmission = car.Transmission || 'Automatic';
  const carStatus = car.Status;
  const carVin = car.Vin || '';
  const carEngine = car.Engine || '';
  const carFuel = car.FuelType || 'Gasoline';
  const carColor = car.ExteriorColor || '';
  const carDrive = car.Driveline || '';

  // Get first image for social sharing
  const firstImage = car.Images?.data?.[0]
    ? `${imgServer}${car.Images.data[0].attributes.url}`
    : 'https://hansentc.ca/assets/images/logo.png';

  const currentUrl =
    window.location.href.split('?')[0] + window.location.search;

  // Enhanced meta description
  const metaDescription = `${carYear} ${carMake} ${carModel} for sale in Brampton. ${carMileage} km, ${carTransmission}, CarFax available. $${carPrice.toLocaleString()}. Book test drive at Hansen Truck & Car Sales serving Mississauga, Caledon & GTA.`;

  // Social media optimized title
  const socialTitle = `${carYear} ${carMake} ${carModel} | $${carPrice.toLocaleString()} | Brampton`;
  const socialDescription = `${
    carStatus === 'Available' ? 'Available now' : 'Recently sold'
  } ${carYear} ${carMake} ${carModel} with ${carMileage} km. CarFax report available. Financing options. Book test drive today!`;

  // Update meta tags
  document
    .getElementById('pageDescription')
    .setAttribute('content', metaDescription);
  document.getElementById('ogTitle').setAttribute('content', socialTitle);
  document
    .getElementById('ogDescription')
    .setAttribute('content', socialDescription);
  document.getElementById('ogImage').setAttribute('content', firstImage);
  document.getElementById('ogUrl').setAttribute('content', currentUrl);
  document.getElementById('twitterTitle').setAttribute('content', socialTitle);
  document
    .getElementById('twitterDescription')
    .setAttribute('content', socialDescription);
  document.getElementById('twitterImage').setAttribute('content', firstImage);
  document
    .getElementById('canonicalUrl')
    .setAttribute('href', currentUrl.split('?')[0]);

  // Generate Vehicle Schema
  const vehicleSchema = {
    '@context': 'https://schema.org/',
    '@type': 'Car',
    name: `${carYear} ${carMake} ${carModel}`,
    brand: {
      '@type': 'Brand',
      name: carMake,
    },
    model: carModel,
    vehicleModelDate: carYear,
    mileageFromOdometer: {
      '@type': 'QuantitativeValue',
      value: carMileage,
      unitCode: 'KTM',
    },
    vehicleTransmission: carTransmission,
    fuelType: carFuel,
    vehicleEngine: carEngine,
    color: carColor,
    driveWheelConfiguration: carDrive,
    vehicleIdentificationNumber: carVin,
    vehicleCondition: 'UsedCondition',
    image: car.Images?.data?.map(
      (img) => `${imgServer}${img.attributes.url}`
    ) || [firstImage],
    offers: {
      '@type': 'Offer',
      price: carPrice,
      priceCurrency: 'CAD',
      availability: carStatus === 'Available' ? 'InStock' : 'OutOfStock',
      priceValidUntil: new Date(Date.now() + 30 * 24 * 60 * 60 * 1000)
        .toISOString()
        .split('T')[0], // 30 days from now
      seller: {
        '@type': 'AutoDealer',
        name: 'Hansen Truck & Car Sales',
        address: {
          '@type': 'PostalAddress',
          streetAddress: '5 Hansen Rd S',
          addressLocality: 'Brampton',
          addressRegion: 'ON',
          postalCode: 'L6W 3H6',
          addressCountry: 'CA',
        },
        telephone: '+19054630928',
        url: 'https://hansentc.ca',
      },
    },
    url: currentUrl,
    category: 'UsedCar',
    keywords: `${carMake}, ${carModel}, ${carYear}, used car, Brampton, Mississauga, Caledon, GTA, Hansen, dealership, ${carTransmission}, warranty, CarFax`,
  };

  // Generate Breadcrumb Schema
  const breadcrumbSchema = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      {
        '@type': 'ListItem',
        position: 1,
        name: 'Home',
        item: 'https://hansentc.ca/',
      },
      {
        '@type': 'ListItem',
        position: 2,
        name: 'Inventory',
        item: 'https://hansentc.ca/inventory.html',
      },
      {
        '@type': 'ListItem',
        position: 3,
        name: `${carYear} ${carMake} ${carModel}`,
        item: currentUrl,
      },
    ],
  };

  // Inject schemas
  document.getElementById('vehicleSchema').textContent =
    JSON.stringify(vehicleSchema);
  document.getElementById('breadcrumbSchema').textContent =
    JSON.stringify(breadcrumbSchema);

  console.log('SEO metadata generated successfully');
};

// Optional: Quick gallery opener for inventory items
window.openCarGallery = function (carId, startIndex = 0) {
  // This could open a quick PhotoSwipe gallery for inventory items
  // Implementation would depend on if you want this feature
  console.log(`Opening gallery for car ${carId} at index ${startIndex}`);
};

Initialize();
